import React, { useEffect, useState } from "react";
import { useDisclosure } from "@mantine/hooks";
import { Modal } from "@mantine/core";
import { graphql, useStaticQuery } from 'gatsby';
import * as letsTalkStyles from "./letsTalk.module.scss";
import Review from "./Components/Review/Review";
import crossButton from "../../../images/home/crossButton.svg";
import SlideUpForm from "../../SlideUpForm/SlideUpForm";
import OurUser from "./Components/OurUser/OurUser";
import user1 from "../../../images/home/user1.jpg";
import user2 from "../../../images/home/user2.jpg";
import user3 from "../../../images/home/user3.jpg";
import HeadingAnimation from "../HeadingAnimation/HeadingAnimation";

export default function LetsTalk() {

  const data = useStaticQuery(graphql`
    query Rating {
      ratingData: wpPage(id: {eq: "cG9zdDoyMjkzMA=="}) {
        id
        title
        reviews {
          reviewItems {
            ratingValue
            link
            title
            elementImage {
              altText
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
        }
      }
    }
  `);


  const apiReviewData = data?.ratingData?.reviews?.reviewItems;

  const [opened, { open, close }] = useDisclosure(false);
  const [innerWidth, setInnerWidth] = useState(0);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setInnerWidth(window.innerWidth);
    }
  }, []);

  return (
    <section className={letsTalkStyles.letsTalk}>
      <div className={letsTalkStyles.letsTalk__container}>
        <div className={letsTalkStyles.letsTalk__headingSection}>
          <div className={letsTalkStyles.letsTalk__heading}>
            <div>
              <HeadingAnimation context={"Got a Project in Mind?"} />
            </div>
            <div className={letsTalkStyles.letsTalk__link}>
              <HeadingAnimation context={"Let's Talk!"} onClick={() => open()} />
              <a 
                className={letsTalkStyles.letsTalk__email} 
                href="mailto:hello@designstudiouiux.com"
              >
                <img src="../../../images/services/envelope.svg" alt="Envelope" /> hello@designstudiouiux.com
              </a>
            </div>
          </div>
          <div className={letsTalkStyles.letsTalk__user}>
            <OurUser
              context={[
                {
                  videoUrl: "",
                  imageUrl: user1,
                  imageText: "User",
                },
                {
                  videoUrl: "",
                  imageUrl: user2,
                  imageText: "User",
                },
                {
                  videoUrl: "",
                  imageUrl: user3,
                  imageText: "User",
                },
              ]}
            />
          </div>
        </div>
        <div className={letsTalkStyles.letsTalk__reviews}>
          {apiReviewData?.map((item, index) => {
            return <Review item={item} key={`item-${index}`} />;
          })}
        </div>

        <Modal.Root
          opened={opened}
          onClose={close}
          transitionProps={{
            transition: "fade-up",
            duration: 100,
            timingFunction: "linear",
          }}
          yOffset={0}
          xOffset={0}
        >
          <Modal.Overlay
            style={{
              backgroundColor: `${innerWidth <= 1170 ? 'rgba(25,30,54,1)' : 'rgba(25,30,54,0.6)'}`,
            }}
          />

          {opened && (
            <button
              className={letsTalkStyles.letsTalk__closeButton}
              onClick={close}
            >
              <span>Close</span>
              <img src={crossButton} alt="crossButton" />
            </button>
          )}

          <Modal.Content
            style={{
              padding: "0",
              display: "block",
              marginTop: "auto",
              height: "90vh",
              alignSelf: "end",
              borderRadius: "20px 20px 0px 0px",
            }}
          >
            <SlideUpForm />
          </Modal.Content>
        </Modal.Root>
      </div>
    </section>
  );
}
